<template>
    <div class="col-6 col-md-5 col-xxl-3">
        <!-- Show loading indicator while waiting for avatar -->
        <div v-if="isLoading" class="loading">
            <SpinningWheel :width="width" :height="height" :borderSize="3" />
        </div>

        <!-- Display avatar once it is available -->
        <div v-else-if="userAvatarUrl">
            <img :src="userAvatarUrl" alt="Avatar" class="avatar-img"
                :style="{ width: width + 'px', height: height + 'px' }" @error="photoFailed = true" />
            <span v-if="user.name && user.name.length > 1" class="hover-text">{{ user.name }}</span>
            <span v-else-if="user.username" class="hover-text">{{ user.username }}</span>
            <span class="hover-text">{{ user_role }}</span>
        </div>

        <!-- Fallback when no avatar is available -->
        <div v-else>
            <icon icon="UserPicture" class="avatar-icon" :style="{ width: width + 'px', height: height + 'px' }" />
            <span v-if="user.name && user.name.length > 1" class="hover-text">{{ user.name }} {{ user_role }}</span>
            <span v-else-if="user.username" class="hover-text">{{ user.username }} {{ user_role }}</span>
            <span class="hover-text">{{ user_role }}</span>
        </div>
    </div>

</template>

<script>
import SpinningWheel from '@/components/SpinningWheel.vue';
export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        user_role: {
            type: String,
            required: false
        },
        width: {
            type: Number,
            required: false,
            default: 45
        },
        height: {
            type: Number,
            required: false,
            default: 45
        }
    },
    components: {
        SpinningWheel,
    },
    data() {
        return {
            hrefPhoto: null,
            isLoading: true,
            photoFailed: false,
        };
    },
    mounted() {
        if (this.user && this.user.avatar) {
            this.downloadPhoto(this.user);
        } else {
            this.isLoading = false;
        }
    },
    computed: {
        userAvatarUrl() {
            if (this.photoFailed) {
                return null;
            }
            return this.hrefPhoto ? this.hrefPhoto : "https://via.placeholder.com/1000";
        },
    },
    methods: {
        async downloadPhoto(user) {
            try {
                const response = await this.$store.getters.api.get('/auth/avatar', {
                    params: { user_id: user.user_id || user.id },
                    responseType: 'blob',
                });
                this.hrefPhoto = URL.createObjectURL(response.data);
            } catch (error) {
                console.error("Failed to download photo", error);
            } finally {
                this.isLoading = false;
            }
        },
    },

};
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.avatar-img {
    padding: 0;
    border-radius: 50%;
}

.avatar-icon {
    font-size: 75px;
    border-radius: 50%;
}

.hover-text {
    display: none;
    position: absolute;
    background-color: $white;
    padding: 5px;
    border: 1px solid $primary;
    z-index: 1;
    font-size: 16px;
}

.avatar-icon:hover+.hover-text {
    display: block;
}

.avatar-img:hover+.hover-text {
    display: block;
}

.loading {
    font-size: 16px;
    color: $primary;
}
</style>
